import req from '@/services/request';

export default class {
  request = req;

  rootCatalogue = '';

  constructor(rootCatalogue) {
    this.rootCatalogue = rootCatalogue;
  }

  getURL(path) {
    return path
      ? `${this.rootCatalogue}/${path}`
      : this.rootCatalogue;
  }

  create(data = {}, config = {}) {
    return this.request.post(this.rootCatalogue, data, config);
  }

  get(id = null, config = {}) {
    return this.request.get(this.getURL(id), config);
  }

  delete(id, config = {}) {
    return this.request.delete(this.getURL(id), config);
  }

  update(id, data = {}, config = {}) {
    return this.request.put(this.getURL(id), data, config);
  }
}
